export const formatName = (fullName) => {
    if (!fullName) return "";
  
    return fullName
      .split(" ")
      .filter(Boolean) // remove extra spaces
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  